import React, { useEffect, useState } from "react";
import { InputLabel, FormControl, MenuItem, Select } from "@mui/material";
import GroupAllUsers from "../FieldTags/GroupAllUsers";
import xplanLabels from "../../util/XplanLabels";
import HistoryLogElement from "./HistoryLogElement";

const newPlan = window.location.pathname === "/xplans/new";
const statuses = [
    "Open",
    "Pending Documentation",
    "Pending Approval",
    "Plan Approved",
    "Real Time",
    "Future Work",
    "Completed",
    "Withdrawn",
    "Archived",
];

const Status = ({ status, handleChange, xplans }) => {
    const [localStatus, setLocalStatus] = useState(status);
    const [hiddenStatuses] = useState(["Plan Approved", "Real Time", "Archived"]);

    useEffect(() => {
        /*
            if (localStatus === "Plan Approved") {
                setHiddenStatuses(["Open", "Withdrawn", "Pending Approval", "Plan Approved"]);
            } else {
                setHiddenStatuses(["Plan Approved"]);
            }
        */
        setLocalStatus(status);
    }, [status]);

    const handleDropdownChange = (e) => {
        setLocalStatus(e.target.value);
        handleChange("status", e.target.value);
    };

    return (
        <div id="status" className="planField">
            <GroupAllUsers />
            <FormControl required={true} className="fullLength" variant="standard">
                <InputLabel shrink={true}>{xplanLabels.status}</InputLabel>
                <Select
                    name="status"
                    value={localStatus ? localStatus : ""}
                    onChange={handleDropdownChange}
                >
                    {statuses.map((menuStatus) => (
                        <MenuItem
                            key={menuStatus}
                            value={menuStatus}
                            style={{
                                display: hiddenStatuses.includes(menuStatus) ? "none" : "block",
                            }}
                        >
                            {menuStatus}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            {!newPlan && <HistoryLogElement xplans={xplans} label={"status"} />}
        </div>
    );
};

export default Status;